// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bx1L","content":"styles_content__17kss","tableWrap":"styles_tableWrap__3kDmt"};